module.exports = __webpack_public_path__ + "img/icons.badd25e5.svg";